"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ = _interopRequireDefault(require("."));

var _Text = require("../Text");

var _Flex = require("../Layout/Flex");

var _Progress = require("../Progress");

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _Constant = require("../Constant");

var _theme;

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  padding: 0 5px;\n  > div {\n    background-color: ", ";\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  width: 300px;\n  margin: auto auto 40px;\n\n  > div {\n    margin: 0 5px;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-top: 0;\n  visibility: hidden;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin-top: 0;\n  font-weight: 700;\n  transition: visibility 0s, opacity 1s ease-in-out;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin: 40px 0;\n  padding: 0 40px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  font-size: 1.3rem;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var TIMEOUT = 30000; // 30 sec

var TextContainer = _styledComponents.default.div(_templateObject());

var Header = _styledComponents.default.p(_templateObject2());

var MessageContainer = _styledComponents.default.div(_templateObject3());

var Message = (0, _styledComponents.default)(_Text.SecondaryH2)(_templateObject4()); // Hidden h2 to set the height of the MessageContainer

var Hidden = (0, _styledComponents.default)(_Text.SecondaryH2)(_templateObject5());
var ProgressContainer = (0, _styledComponents.default)(_Flex.FlexContainer)(_templateObject6());
var barColor = (0, _styledTheming.default)('mode', (_theme = {}, (0, _defineProperty2.default)(_theme, _Constant.Themes.CALIBER, _Constant.Color.TEAL), (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEBRIDGE, _Constant.Color.HOMEBRIDGE_BLUE), (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEPOINT, _Constant.Color.HOMEPOINT_LIGHT_BLUE), (0, _defineProperty2.default)(_theme, _Constant.Themes.SYNERGY_ONE, _Constant.Color.SYNERGY_ONE_YELLOW_DARK), (0, _defineProperty2.default)(_theme, _Constant.Themes.FIGURE, _Constant.Color.TEAL), (0, _defineProperty2.default)(_theme, _Constant.Themes.PETERSENDEAN, _Constant.Color.TEAL), (0, _defineProperty2.default)(_theme, _Constant.Themes.PELLA, _Constant.Color.TEAL), (0, _defineProperty2.default)(_theme, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.GUARANTEED_RATE_ARROW_RED), _theme));
var ProgressBar = (0, _styledComponents.default)(_Progress.ProgressBar)(_templateObject7(), barColor);
/**
 * Modal with loading bars and rotating messages.
 **/

var ProcessingQuoteModal = function ProcessingQuoteModal(_ref) {
  var isOpen = _ref.isOpen,
      closable = _ref.closable,
      header = _ref.header,
      rotatingMessages = _ref.rotatingMessages,
      timeout = _ref.timeout;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      index = _useState2[0],
      setIndex = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  var timePerHeader = timeout / rotatingMessages.length;
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      index < rotatingMessages.length - 1 && setIndex(index + 1);
    }, timePerHeader);
  }, [index, timeout, rotatingMessages.length, timePerHeader]);
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      setValue((value + 1) % 100);
    }, 1);
  }, [value]);
  return /*#__PURE__*/_react.default.createElement(_.default, {
    size: "sm",
    isOpen: isOpen,
    closable: closable,
    maxWidth: 480,
    description: header,
    role: "alert"
  }, /*#__PURE__*/_react.default.createElement(TextContainer, null, /*#__PURE__*/_react.default.createElement(Header, null, header), /*#__PURE__*/_react.default.createElement(MessageContainer, null, rotatingMessages.map(function (k, i) {
    return /*#__PURE__*/_react.default.createElement(Message, {
      key: k.key,
      className: index === i && 'active',
      style: {
        visibility: index === i ? 'visible' : 'hidden',
        opacity: index === i ? '1' : '0'
      }
    }, k.value);
  }), /*#__PURE__*/_react.default.createElement(Hidden, {
    "aria-hidden": "true"
  }, "hidden")), /*#__PURE__*/_react.default.createElement(ProgressContainer, null, rotatingMessages.map(function (k, i) {
    return /*#__PURE__*/_react.default.createElement(ProgressBar, {
      borderRadius: 0,
      value: index > i ? 100 : index === i ? value : 0
    });
  }))));
};

ProcessingQuoteModal.propTypes = {
  isOpen: _propTypes.default.bool,
  closable: _propTypes.default.bool,
  header: _propTypes.default.string,
  rotatingMessages: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string.isRequired,
    value: _propTypes.default.node.isRequired
  })),
  timeout: _propTypes.default.number
};
ProcessingQuoteModal.defaultProps = {
  isOpen: false,
  closable: false,
  header: 'We are retrieving information from your provider.',
  rotatingMessages: [],
  timeout: TIMEOUT
};
var _default = ProcessingQuoteModal;
exports.default = _default;